import type { ConsentCategoryConfig } from "@homeinstead/locale";

/**
 * Prepare a video URL for embedding based on Osano marketing consent.
 */
export function prepareVideoURL(
  url: string,
  cookieConsent?: ConsentCategoryConfig,
): string {
  if (cookieConsent?.["MARKETING"] !== "ACCEPT") {
    // Use privacy-enhanced mode for YouTube videos
    return url.replace("youtube.com", "youtube-nocookie.com");
  }

  return url;
}
